<div class="dashboard-header">
  <h2 class="dashboard-title" *ngIf="configurations?.['dashboard-name']">
    {{ configurations['dashboard-name'] }}
  </h2>
  <div class="header-right">
    <!-- Reset icon left of Insight icon, both left of toggle -->
    <div class="header-action-group" *ngIf="showHeaderReset || showHeaderInsight" [class.only-reset]="showHeaderReset && !showHeaderInsight">
      @if(showHeaderReset) {
      <button class="header-reset-btn" (click)="onHeaderReset()" matTooltip="Reset filters" title="Reset filters" style="--btn-color: #ffffff;">
        <mat-icon class="material-symbols-outlined" style="font-family: 'Material Symbols Outlined' !important;">filter_alt_off</mat-icon><span class="header-reset-text ms-1">Reset</span>
      </button>
      }
      @if(showHeaderReset && showHeaderInsight) {
      <div class="header-divider" style="width: 1px; height: 16px; background: #ffffff; margin: 0 4px; align-self: center; opacity: 1;"></div>
      }
      @if(showHeaderInsight) {
      <app-button class="header-action-btn" [data]="headerInsightConfig" [selectedKey]="headerInsightKey"
        [showResetButton]="false" (selectionChange)="onHeaderInsight($event)">
      </app-button>
      }
    </div>
    @if(configurations?.toggleButton) {
    <app-toggle-button [data]="configurations.toggleButton"></app-toggle-button>
    }
  </div>
</div>

@if(!!configurations?.filters) {
<div class="filter-bar-wrapper">
  <div class="filter-left">
    <app-global-filter [config]="configurations?.filters" [hideInternalButtons]="true"></app-global-filter>
  </div>
</div>
}

<div class="dashboard-content" [class.no-scroll-content]="!screenFloating" [style.margin-top.px]="chartOffsetTop">
  @for (item of configurations?.pageContent; track $index) {
  <div class="row gx-2 gy-0">
    <h4 class="title" *ngIf="item?.title">{{ item?.title }}</h4>

    @for (column of item?.columns; track $index) {
    <div class="col {{ column?.class }}">
      <!-- If column is a widget -->
      @if (column?.type) {
      <app-widget-renderer [charts]="column"></app-widget-renderer>
      }

      <!-- Nested rows inside column -->
      @if (column?.rows?.length > 0) {
      @for (nestedItem of column.rows; track $index) {

      <!-- If nestedItem is a widget (has type) -->
      @if(nestedItem?.type) {
      <div class="col {{ nestedItem?.class }}">
        <app-widget-renderer [charts]="nestedItem"></app-widget-renderer>
      </div>
      }

      <!-- If nestedItem is a row (has columns) -->
      @if(nestedItem?.columns?.length > 0) {
      <div class="row">
        <h4 class="title">{{ nestedItem?.title }}</h4>
        @for (nestedCol of nestedItem.columns; track $index) {
        <div class="col {{ nestedCol?.class }}">
          <app-widget-renderer [charts]="nestedCol"></app-widget-renderer>
        </div>
        }
      </div>
      }
      }
      }
    </div>
    }
  </div>
  }
</div>